<template>
  <div>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <!-- RG -->
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Registro Geral
                  <span v-if="cadastrado.mostraMultiplosRegistros">- {{ cadastrado.registro | formataRegistro }}</span>
                </h4>
                <div class="row">
                  <form>
                    <div class="row row-field">
                      <field-validation css-class="col-sm-3" label="RG" field="rgNumero" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false"
                        :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                        <input type="text" name="rgNumero" id="rgNumero" class="form-control"
                          v-model="cadastrado.pessoa.rg.numero" v-validate="'required'" data-vv-as="RG"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                          @focus="removeMascaraRg" @blur="aplicaMascaraRg" @input="limitaRgInput"
                          @change="zeraDataEmissao()" />
                      </field-validation>
                      <div class="col-sm-3">
                        <div v-if="!cadastrado.lancamentoPermitido">
                          <campo-calendario rotulo="Data da Emissão" nome="dataEmissao" :validacao="{ required: true }"
                            v-model="cadastrado.pessoa.rg.dataEmissao" :disabled="situacaoRecad === 'CONFIRMADO'" />
                        </div>
                        <div v-else>
                          <label for="dataEmissao">Data da Emissão</label>
                          <p class="textoAlinhadoAoInput form-control" style="background-color: #eeee;opacity:1">
                            {{ formatarData(cadastrado.pessoa.rg.dataEmissao) }}
                          </p>
                        </div>
                      </div>
                      <field-validation css-class="col-sm-3" label="Orgão Emissor" field="orgaoEmissor" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="text" name="orgaoEmissor" id="orgaoEmissor" class="form-control"
                          v-model="cadastrado.pessoa.rg.orgaoEmissor"
                          v-sem-acentos
                           v-validate="'required|max:5'"
                          data-vv-as="Orgão Emissor"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-3" label="Estado Emissor" field="uf" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <select class="form-control" name="uf" v-model="cadastrado.pessoa.rg.uf" v-validate="'required'"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                          data-vv-as="Estado Emissor">
                          <option value :selected="true">Escolha</option>
                          <option v-for="uf in ufs" :value="uf.sigla" :key="uf.sigla"
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                            {{ uf.nome | tudoMaiusculo }}
                          </option>
                        </select>
                      </field-validation>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Título de Eleitor -->
            <div class="card card-default">
              <div class="card-content">
                <h4>Título de Eleitor</h4>
                <div class="row">
                  <form>
                    <div class="row row-field">
                      <field-validation css-class="col-sm-6" label="Título" field="tituloNumero" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="tituloNumero" id="tituloNumero" class="form-control"
                          v-model="cadastrado.pessoa.tituloEleitor.numero" v-mask="'####.####.#####'"
                          v-validate="'required'" data-vv-as="Título"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-3 col-xs-6" label="Zona" field="zona" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="zona" id="zona" class="form-control"
                          v-model="cadastrado.pessoa.tituloEleitor.zona" v-mask="'###'" v-validate="'required'"
                          data-vv-as="Zona"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-3 col-xs-6" label="Seção" field="secao" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="secao" id="secao" class="form-control"
                          v-model="cadastrado.pessoa.tituloEleitor.secao" v-mask="'####'" v-validate="'required'"
                          data-vv-as="Seção"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Trabalhista -->
            <div class="card card-default">
              <div class="card-content">
                <h4>Trabalhista</h4>
                <div class="row">
                  <form>
                    <div class="row row-field">
                      <field-validation css-class="col-sm-4" label="PIS/PASEP" field="pisPasep" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="pisPasep" id="pisPasep" class="form-control"
                          v-model="cadastrado.pessoa.pisPasep" v-mask="'###.#####.##-#'" v-validate="'required'"
                          data-vv-as="PIS/PASEP"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-4" label="Orgão de Classe" field="orgaoClasse"
                        :status="errors" :custom-errors="apiErrors" :show-icon="false">
                        <input type="text" name="orgaoClasse" id="orgaoClasse" class="form-control"
                          v-model="cadastrado.pessoa.orgaoClasse.descricao" 
                          v-sem-acentos
                          v-validate="'max:7'"
                          data-vv-as="Orgão de Classe"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-4" label="Número" field="numeroOrgao" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="numeroOrgao" id="numeroOrgao" class="form-control"
                          v-model="cadastrado.pessoa.orgaoClasse.numero"
                          v-validate="{ required: temOrgaoClasse, max: 10 }" data-vv-as="Número"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- CNH -->
            <div class="card card-default" v-if="cadastrado.pessoa.motorista">
              <div class="card-content">
                <h4>Carteira de Habilitação</h4>
                <div class="row">
                  <form>
                    <div class="row row-field">
                      <field-validation css-class="col-sm-4" label="CNH" field="numeroCnh" :status="errors"
                        :custom-errors="apiErrors" :show-icon="false">
                        <input type="tel" name="numeroCnh" id="numeroCnh" class="form-control"
                          v-model="cadastrado.pessoa.cnh.numero" v-mask="'############'"
                          v-validate="'required|is_not:0'" data-vv-as="CNH"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </field-validation>
                      <field-validation css-class="col-sm-4 col-xs-6" label="Categoria" field="categoria"
                        :status="errors" :custom-errors="apiErrors" :show-icon="false">
                        <select class="form-control" name="categoria" v-model="cadastrado.pessoa.cnh.categoria"
                          v-validate="'required'" data-vv-as="Categoria"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                          <option value :selected="true">Escolha</option>
                          <option v-for="categoria in categorias" :value="categoria.codigo" :key="categoria.id"
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                            {{ categoria.codigo }}
                          </option>
                        </select>
                      </field-validation>
                      <div class="col-sm-4 col-xs-6">
                        <campo-calendario rotulo="Validade" nome="validadeCnh" :data-maxima="daquiADezAnos"
                          :validacao="{ required: true }" v-model="cadastrado.pessoa.cnh.validade"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao estilo="vazado-verde-esq" rotulo="Voltar" icone="voltar" @clicado="volta()" />
            <botao estilo="cheio-verde-dir" rotulo="Avançar" icone="avancar" :icone-direita="true"
              @clicado="avanca(cadastrado, 'Filiacao')" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Botao from '@/components/botao';
import CampoCalendario from '@/components/campo-calendario';
import StringHelper from '@/helpers/StringHelper';
import DateHelper from '@/helpers/DateHelper';
import NullHelper from '@/helpers/NullHelper';
import moment from 'moment';
import Hash from 'object-hash';
import { getEstados } from '@/services/estadoService';

export default {
  name: 'Documentacao',

  data() {
    return {
      cadastrado: this.$store.state.funcionarioCadastrado,
      //ufs: this.$store.state.estados,
      ufs: [],
      categorias: [
        { id: 1, codigo: 'A' },
        { id: 2, codigo: 'AB' },
        { id: 3, codigo: 'AC' },
        { id: 4, codigo: 'AD' },
        { id: 5, codigo: 'AE' },
        { id: 6, codigo: 'B' },
        { id: 7, codigo: 'C' },
        { id: 8, codigo: 'D' },
        { id: 9, codigo: 'E' },
      ],
      apiErrors: null,
      cnh: {
        numero: 0,
        categoria: '',
        validade: '',
      },
      orgaoClasse: {
        descricao: '',
        numero: '',
      },
      rg: {
        dataEmissao: '',
        numero: '',
        orgaoEmissor: '',
        uf: '',
      },
      tituloEleitor: {
        numero: 0,
        secao: 0,
        zona: 0,
      },
      X: {
        pattern: /[0-9A-Z]/,
      },
    };
  },

  computed: {
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    temRg() {
      return this.cadastrado.pessoa.rg.numero ? true : false;
    },

    temTituloEleitoral() {
      return this.cadastrado.pessoa.tituloEleitor.numero ? true : false;
    },
    temOrgaoClasse() {
      if (this.cadastrado.pessoa.orgaoClasse) {
        return this.cadastrado.pessoa.orgaoClasse.descricao ? true : false;
      }
      return false;
    },
    daquiADezAnos() {
      return moment(new Date()).add(10, 'years').format('YYYY-MM-DD');
    },
  },

  methods: {
    async obtemEstados() {
      try {
        const estadosData = getEstados();
        this.ufs = estadosData.map(estado => ({
          id: estado.id,
          nome: estado.nome,
          sigla: this.getSiglaFromNome(estado.nome)
        }));
      } catch (error) {
        console.error('Erro ao carregar estados:', error);
        this.emiteAlerta("Erro ao carregar estados");
      }
    },
    getSiglaFromNome(nome) {
      const siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    volta() {
      this.$validator.validateAll().then(success => {
        if (success) {
          if (this.validaDatas(this.cadastrado)) {
            this.$router.go(-1);
            return;
          }
          this.$root.$refs.toastr.e('Preencha as datas necessárias', 'Atenção');
          return;
        }
        this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    avanca(cadastrado, proximoLink) {
      this.$validator.validateAll().then(success => {
        if (success) {
          // Só implementa o avanca() se for para outra tela
          if (proximoLink !== 'Documentacao') {
            if (this.validaDatas(cadastrado)) {
              this.formataParaApi(cadastrado);
              this.setAnexos(cadastrado, this.$store.state.cadastroModelo);
              this.$store.commit('setFuncionarioCadastrado', cadastrado);
              this.$router.push({ name: proximoLink });
              return;
            }
            this.$root.$refs.toastr.e(
              'Preencha as datas necessárias',
              'Atenção',
            );
            return;
          }
          return;
        }
        this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    zeraDataEmissao() {
      this.cadastrado.pessoa.rg.dataEmissao = null;
    },
    limitaRgInput(event) {
      // Limita a entrada a apenas números e no máximo 11 dígitos
      const valor = event.target.value;
      const apenasNumeros = valor.replace(/[^0-9xX]/g, '').toUpperCase();
      if (apenasNumeros.length > 11) {
        this.cadastrado.pessoa.rg.numero = apenasNumeros.substring(0, 11);
      }
    },
    removeMascaraRg() {
      // Remove a máscara quando o campo recebe foco
      if (!this.cadastrado.pessoa.rg.numero) return;
      const apenasNumeros = String(this.cadastrado.pessoa.rg.numero).replace(/[^0-9xX]/g, '').toUpperCase();
      this.cadastrado.pessoa.rg.numero = apenasNumeros;
    },
    aplicaMascaraRg() {
      // Aplica a máscara quando o campo perde o foco
      const numero = String(this.cadastrado.pessoa.rg.numero || '').replace(/[^0-9xX]/g, '').toUpperCase();
      if (!numero) return;

      const tamanho = numero.length;

      if (tamanho === 11) {
        // Aplica máscara de CPF: 000.000.000-00
        this.cadastrado.pessoa.rg.numero = numero.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4'
        );
      } else if (tamanho === 8 || tamanho === 9) {
        // Aplica máscara de RG padrão
        if (tamanho === 9) {
          // RG com 9 dígitos: 00.000.000-0
          this.cadastrado.pessoa.rg.numero = numero.replace(
             /^(\d{2})(\d{3})(\d{3})([\dxX]{1})$/,
             '$1.$2.$3-$4'
          );
        } else {
          // RG com 8 dígitos: 00.000.000
          this.cadastrado.pessoa.rg.numero = numero.replace(
            /^(\d{2})(\d{3})(\d{3})$/,
            '$1.$2.$3'
          );
        }
      }
      // Se tiver outro tamanho, mantém sem máscara
    },
    validaDatas(cadastrado) {
      let { motorista, cnh, rg } = cadastrado.pessoa;
      const dataCnhValida = !motorista || cnh.validade;
      const dataRgValida = !rg.numero || rg.dataEmissao;

      return dataCnhValida && dataRgValida;
    },
    valoraNulos(pessoa) {
      pessoa.cnh = NullHelper.valora(pessoa.cnh, this.cnh);
      pessoa.orgaoClasse = NullHelper.valora(
        pessoa.orgaoClasse,
        this.orgaoClasse,
      );
      pessoa.rg = NullHelper.valora(pessoa.rg, this.rg);
      pessoa.tituloEleitor = NullHelper.valora(
        pessoa.tituloEleitor,
        this.tituloEleitor,
      );
    },
    resetaNulos(pessoa) {
      pessoa.cnh = NullHelper.reseta(pessoa.cnh, this.cnh);
      pessoa.orgaoClasse = NullHelper.reseta(
        pessoa.orgaoClasse,
        this.orgaoClasse,
      );
      pessoa.rg = NullHelper.reseta(pessoa.rg, this.rg);
      pessoa.tituloEleitor = NullHelper.reseta(
        pessoa.tituloEleitor,
        this.tituloEleitor,
      );
    },
    formataParaApi(cadastrado) {
      let { rg, tituloEleitor, cnh, pisPasep, orgaoClasse } = cadastrado.pessoa;
      const limpa = numero => StringHelper.limpaFormato(numero);
      const limpaRg = rg => StringHelper.limpaFormato(rg, true);
      const numerifica = numero => parseInt(numero);
      const dataParaPtbr = data => DateHelper.convertPtbrToApiDate(data);

      rg.numero = limpaRg(rg.numero);
      rg.dataEmissao = dataParaPtbr(rg.dataEmissao);
      tituloEleitor.numero = limpa(tituloEleitor.numero);
      tituloEleitor.numero = numerifica(tituloEleitor.numero);
      tituloEleitor.zona = numerifica(tituloEleitor.zona);
      tituloEleitor.secao = numerifica(tituloEleitor.secao);
      cnh.numero = numerifica(cnh.numero);
      cnh.validade = dataParaPtbr(cnh.validade);

      // Corrigindo o problema do PIS/PASEP
      if (pisPasep) {
        pisPasep = limpa(pisPasep);
        cadastrado.pessoa.pisPasep = numerifica(pisPasep);
      } else {
        cadastrado.pessoa.pisPasep = null;
      }

      this.tiraAcentuacao(rg, orgaoClasse);
      this.resetaNulos(cadastrado.pessoa);
    },
    tiraAcentuacao(rg, orgaoClasse) {
      if (orgaoClasse) {
        let camposOrgao = [orgaoClasse.descricao, orgaoClasse.numero];
        let indexOrgao = 0;

        camposOrgao.map(element => {
          if (StringHelper.verificaCaracterEspecial(element)) {
            camposOrgao[indexOrgao] = StringHelper.limpaCaracterEspecial(
              element,
            );
            this.$root.$refs.toastr.w(
              'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
              'Atenção',
            );
          }
          indexOrgao++;
        });
        this.cadastrado.pessoa.orgaoClasse.descricao = camposOrgao[0];
        this.cadastrado.pessoa.orgaoClasse.numero = camposOrgao[1];
      }

      if (StringHelper.verificaCaracterEspecial(rg.orgaoEmissor)) {
        rg.orgaoEmissor = StringHelper.limpaCaracterEspecial(rg.orgaoEmissor);
        this.$root.$refs.toastr.w(
          'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
          'Atenção',
        );
      }
    },
    normalizaEndereco(endereco) {
      if (!endereco) return null;

      return {
        cep: endereco.cep || '',
        tipoLogradouro: endereco.tipoLogradouro || '',
        logradouro: endereco.logradouro || '',
        numero: endereco.numero || 0,
        complemento: endereco.complemento || '',
        bairro: endereco.bairro || '',
        cidade: endereco.cidade || '',
        uf: endereco.uf || ''
      };
    },

    normalizaContato(contato) {
      if (!contato) return null;

      return {
        dddTelefone: contato.dddTelefone ? parseInt(contato.dddTelefone) : null,
        numeroTelefone: contato.numeroTelefone ? String(contato.numeroTelefone).replace(/\D/g, '') : null,
        dddCelular: contato.dddCelular ? parseInt(contato.dddCelular) : null,
        numeroCelular: contato.numeroCelular ? String(contato.numeroCelular).replace(/\D/g, '') : null,
        email: contato.email || ''
      };
    },

    normalizaDocumentos(pessoa) {
      if (!pessoa) return null;

      // Cria cópias para normalizar
      const pessoaNormalizada = JSON.parse(JSON.stringify(pessoa));

      // Normaliza RG
      if (pessoaNormalizada.rg) {
        pessoaNormalizada.rg = {
          numero: String(pessoaNormalizada.rg.numero || '').replace(/\D/g, ''),
          dataEmissao: pessoaNormalizada.rg.dataEmissao,
          orgaoEmissor: pessoaNormalizada.rg.orgaoEmissor || '',
          uf: pessoaNormalizada.rg.uf || ''
        };
      }

      // Normaliza Título de Eleitor
      if (pessoaNormalizada.tituloEleitor) {
        pessoaNormalizada.tituloEleitor = {
          numero: parseInt(String(pessoaNormalizada.tituloEleitor.numero || '').replace(/\D/g, '')) || 0,
          zona: parseInt(pessoaNormalizada.tituloEleitor.zona || 0),
          secao: parseInt(pessoaNormalizada.tituloEleitor.secao || 0)
        };
      }

      // Normaliza PIS/PASEP
      if (pessoaNormalizada.pisPasep) {
        pessoaNormalizada.pisPasep = parseInt(String(pessoaNormalizada.pisPasep).replace(/\D/g, '')) || 0;
      }

      // Normaliza Órgão de Classe
      if (pessoaNormalizada.orgaoClasse) {
        pessoaNormalizada.orgaoClasse = {
          descricao: pessoaNormalizada.orgaoClasse.descricao || '',
          numero: pessoaNormalizada.orgaoClasse.numero || ''
        };
      }

      // Normaliza CNH
      if (pessoaNormalizada.cnh) {
        pessoaNormalizada.cnh = {
          numero: parseInt(String(pessoaNormalizada.cnh.numero || '').replace(/\D/g, '')) || 0,
          categoria: pessoaNormalizada.cnh.categoria || '',
          validade: pessoaNormalizada.cnh.validade
        };
      }

      return pessoaNormalizada;
    },
    setAnexos(cadastrado, original) {
      // Normaliza os dados antes de comparar
      const pessoaNormalizada = this.normalizaDocumentos(cadastrado.pessoa);
      const originalNormalizada = this.normalizaDocumentos(original.pessoa);

      const rg = Hash(pessoaNormalizada.rg) != Hash(originalNormalizada.rg) ? true : false;
      const tituloEleitor = Hash(pessoaNormalizada.tituloEleitor) != Hash(originalNormalizada.tituloEleitor) ? true : false;
      const pisPasep = Hash(pessoaNormalizada.pisPasep) != Hash(originalNormalizada.pisPasep) ? true : false;
      const orgaoClasse = Hash(pessoaNormalizada.orgaoClasse) != Hash(originalNormalizada.orgaoClasse) ? true : false;
      const cnh = Hash(pessoaNormalizada.cnh) != Hash(originalNormalizada.cnh) ? true : false;

      let documentos = [];

      if (rg) documentos.push('RG (caso ainda não estiver anexado)');
      if (tituloEleitor) documentos.push('Título de Eleitor');
      if (pisPasep) documentos.push('PIS/PASEP');
      if (orgaoClasse) documentos.push('Documento oficial do Conselho de Classe');
      if (cnh) documentos.push('Carteira de Habilitação');

      if (cadastrado.documentosExigidos) {
        const novosDocumentos = documentos.filter(
          item => !cadastrado.documentosExigidos.includes(item),
        );
        cadastrado.documentosExigidos = [
          ...cadastrado.documentosExigidos,
          ...novosDocumentos,
        ];
      } else {
        cadastrado.documentosExigidos = [...documentos];
      }
    },
    formatarData(data) {
      if (!data) return '';
      const dataObj = new Date(data);
      return dataObj.toLocaleDateString('pt-BR'); // Formato dd/mm/yyyy
    },
  },

  created() {
    this.obtemEstados();
    this.valoraNulos(this.cadastrado.pessoa);
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.avanca(this.cadastrado, nomeComponente);
    });
  },

  mounted() {
    window.scrollTo(0, 0);
    // Aplica a máscara do RG ao carregar a tela (para exibição correta mesmo sem edição)
    this.aplicaMascaraRg();
  },

  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },

  components: {
    Botao,
    CampoCalendario,
  },
};
</script>

<style scoped>
.card {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// index.vue?126c03d2